export default __webpack_public_path__ + "static/tech_uk-ff8616ab15b73066b6ad761e9d1580f0.png";